import { Locale, type LocalizedString } from "../Locale.js";

export const contactPathMap = {
	[Locale.cs]: "kontakt" as const,
} satisfies LocalizedString;
